import React from 'react';

/** Private MIME type so a folder only accepts drags that started on a candidate row or card. */
export const CANDIDATE_DRAG_TYPE = 'application/x-candibank-candidates';

/**
 * Start dragging a candidate. Dragging a row that is part of the selection drags the whole
 * selection; dragging any other row drags just that one.
 */
export function startCandidateDrag(
  e: React.DragEvent,
  candidateId: string,
  selectedIds: string[],
) {
  const ids = selectedIds.includes(candidateId) ? selectedIds : [candidateId];
  e.dataTransfer.setData(CANDIDATE_DRAG_TYPE, JSON.stringify(ids));
  e.dataTransfer.effectAllowed = 'copy';

  const badge = document.createElement('div');
  badge.textContent = ids.length === 1 ? '1 candidate' : `${ids.length} candidates`;
  badge.style.cssText =
    'position:absolute;top:-1000px;padding:4px 10px;border-radius:6px;background:#4f46e5;' +
    'color:#fff;font:600 12px system-ui,sans-serif;';
  document.body.appendChild(badge);
  e.dataTransfer.setDragImage(badge, 0, 0);
  setTimeout(() => badge.remove(), 0);
}

export function isCandidateDrag(e: React.DragEvent) {
  return Array.from(e.dataTransfer.types).includes(CANDIDATE_DRAG_TYPE);
}

export function readCandidateDrag(e: React.DragEvent): string[] {
  try {
    const ids = JSON.parse(e.dataTransfer.getData(CANDIDATE_DRAG_TYPE));
    return Array.isArray(ids) ? ids.filter((id) => typeof id === 'string') : [];
  } catch {
    return [];
  }
}
